import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/51/thumb-landscape.jpg"


const Post51 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／ファーストミディアム／31 x26 x10cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>2021-22年秋冬ウィメンズコレクションにて登場したFENDI FIRST（フェンディ ファースト）。<br></br>ソフトなクラッチのフレームにブランドの頭文字「F」が斜めに配置された、フェンディらしいモダンでスタイリッシュなフォルムがポイントとなっており、登場から世界中のファッショニスタたちを虜にしています。<br></br>今回は、FENDI FIRST（フェンディ ファースト）について詳しくご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.FENDI FIRST（フェンディ ファースト）とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.FENDI FIRST（フェンディ ファースト）のサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.FENDI FIRST（フェンディ ファースト）の持ち方</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.FENDI FIRST（フェンディ ファースト）のおすすめコーデ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.まとめ</ScrollLink>            
        </p>
      </div>
      <div name="sec1" className="text-max-width">
        <h2>1.FENDI FIRST（フェンディ ファースト）とは？</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/51/1.jpg" alt="スタイリッシュなフォルムが人気♡FENDI FIRST（フェンディ ファースト）"/>
      </figure>
      <span className="text-center">（写真はミディアム）</span>
      <p className="text-max-width">まもなく創業100周年を迎えるローマの老舗ラグジュアリーブランド「FENDI」（2025年で創業100年）。<br></br>2020年、55年ぶりになる新アーティスティック ディレクターに着任したキム・ジョーンズのデビューコレクションとしても話題を呼んだFENDIの新たなアイコンバッグ。FENDIの新たな1ページの意味が込められたFENDI FIRST（フェンディ ファースト）は、モードと機能美を両立したバッグです。<br></br>また2022-23年秋冬コレクションの新作では、FENDI FIRST（フェンディ ファースト）の鮮やかなファーバッグも発表されています。エコファー（ヴィーガンファー、フェイクファー）が主となってきている昨今、リアルファーバッグ？と驚いた方も多いのでは？<br></br>実はこちらのファーも、ほかのプロセスにおいて廃棄となったフォックスファーを使用したアップサイクル素材で、縫い目が表から見えないようファーステッチを用いて断片を縫い合わせ、パッチワークのように仕上げているとの事。サステナビリティへの配慮もされており、さすがFENDIといったバッグですね。<br></br>キム・ジョーンズがディレクションする新生フェンディは、インパクトがありながらも、タイムレスなデザインで世界を魅了しており、FENDI FIRST（フェンディ ファースト）はまさにその代表的なバッグです。
      </p>
      <div name="sec2" className="text-max-width">
        <h2>2.FENDI FIRST（フェンディ ファースト）のサイズ展開</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/51/2.jpg"/>
      </figure>
      <span className="text-center">写真：左：ミディアム、右：スモール</span>
      <div className="text-max-width">
        <h2>■FENDI FIRST SMALL（フェンディ ファーストスモール）/24x16x9cm（幅x高さxマチ)</h2>
        <p>スモールサイズながら、長財布やスマートフォンの収納も可能。取り外し可能なショルダーストラップ付きで、ショルダーバッグとしてもクラッチバッグとしても使いやすいサイズ感です。</p>
      </div>
      <div className="text-max-width">
        <h2>■FENDI FIRST MEDIUM（フェンディ ファーストミディアム）/31x26x10cm（幅x高さxマチ)</h2>
        <figure>
        <StaticImage src="../../images/posts/51/3.jpg"/>
        </figure>
        <p>ミディアムサイズは、ポーチやB5サイズの手帳が入るほどの収納力。エレガントながら収納力に優れており、付属のレザーストラップの太さ、短さのバランスも◎。</p>
      </div>      
      <figure>
        <StaticImage src="../../images/posts/51/4.jpg"/>
      </figure>
      <p>ライニングには、FENDIのFを重ねたズッカ柄が♡</p>
      <div name="sec3" className="text-max-width">
        <h2>3.FENDI FIRST（フェンディ ファースト）の持ち方</h2>      
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/51/5.jpg"/>
      </figure>
      <p className="text-max-width">
      柔らかいナッパレザーを使用しており、ショルダーストラップでデイリーに。ドレススタイルには、クラッチとして掴み持ちすれば今っぽいスタイルに。<br></br>FENDIといえばバケット（BAGUETTE）バッグといったイメージの大人世代の方々にも、【UNDER THE ARM】=小脇に抱えるバッグスタイル　が改めて新鮮に思えるはず。
      </p>
      <div name="sec4" className="text-max-width">
        <h2>4.FENDI FIRST（フェンディ ファースト）のおすすめコーデ</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/51/6.png"/>
      </figure>
      <p className="text-max-width">
      今季復活のロングブーツと合わせて、大人カジュアルに♡
      </p>                                                                                  
      <div name="sec5" className="text-two-cloumn">
        <h2>5.まとめ</h2>
        <p>いかがでしたか？FENDI の新たなアイコンバッグ、FENDI FIRST（フェンディ ファースト）。ぜひ一度使ってみてはいかがでしょうか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
       フェンディのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post51

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 51}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
